import { getValueByPath } from 'utils-lib/dist/object';
import { findParentComponent } from '../utils/helper';

export default {
  data() {
    return {
      parentForm: null
    };
  },
  props: {
    /**
     * @ignore ignore
     */
    size: String
  },
  computed: {
    // 尺寸
    curSize() {
      return this.size || getValueByPath(this.parentForm, 'size');
    }
  },
  mounted() {
    this.parentForm = this.getParentForm();
  },
  methods: {
    getParentForm() {
      return findParentComponent(this, 'hive-form');
    }
  }
};
